<se-modalwindow [visible]="visible"
                [closeOnHeader]="closeOnHeader"
                [zIndex]="zIndex"
                (visibleChange)="onVisibileChange($event)"
                [closable]="closable"
                [fixedWidthPx]="fixedWidthPx"
                [windowSize]="windowSize">
    <div #containerDiv class="dialog-container">
        <div class="se-dialog-header mat-elevation-z6" [class.se-dialog-header-error]="isError" [class.se-dialog-header-warning]="isWarning">
           <h3 class="se-dialog-title" mat-dialog-title>{{header | translate}}</h3>
           <mat-icon *ngIf="closeOnHeader"(click)="onClose()" style="font-size: medium; margin-right:10px" fontSet="estensa-icons">icon_cross</mat-icon>
         </div>
        <div class="se-dialog-content" [class.se-dialog-content-no-padding]="noPaddingInContent">
            <div class="se-dialog-message-container" *ngIf="!description">
                <ng-content select="[content]"></ng-content>
            </div>
            <p class="se-dialog-message-container" *ngIf="!!description">{{description}}</p>
            <div class="se-dialog-action-container">
                <button *ngIf="buttonOk" mat-button (click)="onOk()" #btnOk color="primary" class="se-dialog-action-button" type="button"
                       [disabled]="onIsButtonOkDisabled()">
                    <p style="margin:0" translate>Ok</p>
                </button>
                <button *ngIf="buttonCancel" mat-button (click)="onCancel()" class="se-dialog-action-button" type="button">
                    <p style="margin:0" translate>Cancel</p>
                </button>

                <button *ngIf="buttonYes" mat-button (click)="onYes()" #btnYes color="primary" class="se-dialog-action-button" type="button">
                    <p style="margin:0" translate>Yes</p>
                </button>
                <button *ngIf="buttonNo" mat-button (click)="onNo()" class="se-dialog-action-button" type="button">
                    <p style="margin:0" translate>No</p>
                </button>
                <button *ngIf="buttonClose" mat-button (click)="onClose()" class="se-dialog-action-button" type="button">
                    <p style="margin:0" translate>Close</p>
                </button>
            </div>
        </div>
    </div>
</se-modalwindow>
